<script>
import { required } from "vuelidate/lib/validators";
export default {
    name: "BidItemModal",
    props: {
        modalTitle: String,
    },
    data(){
        return {
            submitted: false,
            form: {
                id: 0,
                prItemId: 0,
                bidItemName: null,
                bidDescription: null,
            },
        }
    },
    validations: {
        form: {
            bidItemName: { required },
        },
    },
    methods: {
        updateData(rfqItem){
            this.form = {
                id: rfqItem.id,
                prItemId: rfqItem.prItemId,
                bidItemName: rfqItem.bidItemName,
                bidDescription: rfqItem.bidDescription,
                itemName: rfqItem.itemName,
                itemDescription: rfqItem.description
            }
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            this.$emit('update', this.form);
        }
    }
}
</script>
<template>
    <b-modal
        id="bid-item-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <form @submit.prevent="onCreate" class="needs-validation">
            <div class="mb-3">
                <label class="d-block mb-0 line-height-1">Bid Item Name</label>
                <small class="text-yellow">Item Name: {{form.itemName}}</small>
                <input
                    v-model="form.bidItemName"
                    class="form-control mt-2"
                    role="textbox"
                    placeholder="Enter Bid Item Name"
                    :class="{'is-invalid': submitted &&  $v.form.bidItemName.$error}"
                />
                <div 
                    v-if="submitted && $v.form.bidItemName.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.bidItemName.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label class="d-block mb-0 line-height-1">Bid Item Description</label>
                <small class="text-yellow">Description: {{form.itemDescription}}</small>
                <textarea
                    v-model="form.bidDescription"
                    class="form-control mt-2"
                    placeholder="Enter Bid Item Description"
                    rows="3"
                >
                </textarea>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success">
                    <i class="bx bx-check"></i> Update Item
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('bid-item-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>